import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance";

export const getSingleOrderDetails = (id: string) => {
  return axiosPrivate.get(`/dashboard/api/v1/orders/${id}`);
};